"use client";

import Link from "next/link";
import { useTranslation } from "react-i18next";
import SectionContainer from "@/common/SectionContainer";

const NewsroomNotFound = () => {
  const { t } = useTranslation();

  return (
    <SectionContainer className="bg-[#f5f5f5]">
      <div className="text-[#222222] min-h-[calc(100vh-5rem)] mt-20 px-5 md:px-20 py-10 max-w-[1280px] mx-auto flex items-center">
        <div className="mx-auto w-full max-w-[520px] bg-white border border-[#e5e7eb] rounded-2xl shadow-sm p-8 text-center space-y-5!">
          <h2 className="text-xl font-bold">{t("NEWSROOM_NOT_FOUND_TITLE")}</h2>
          <p className="text-gray-600">{t("NEWSROOM_NOT_FOUND_DESCRIPTION")}</p>
          <Link
            href="/newsroom"
            className="inline-flex items-center justify-center w-full px-6 py-2.5 bg-[#2b7fff] text-white text-sm font-medium rounded-lg hover:bg-[#1a6ae8] text-white! transition-colors"
          >
            {t("NEWSROOM_NOT_FOUND_BACK")}
          </Link>
        </div>
      </div>
    </SectionContainer>
  );
};

export default NewsroomNotFound;
